<template>
	<div>
		<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">工资明细表</div>
		<el-row style="margin-top: 15px;">
			<el-col :span="4" style="background-color: #f7f8fa; height: 750px;">
				<Structure ref="Structure" @parentFind="Find" :condition="condition"></Structure>
			</el-col>
			<el-col :span="20" class="tabs">
				<el-tabs v-model="activeName" @tab-click="handleClick" type="card">
					<el-tab-pane label="项目工资明细表" name="XmGzmx">
						<div style="margin-top:2px">
							<div>
								<el-row>
									<div style="height: 660px;padding-bottom: 100px; background-color: #FFFFFF; ">

										<el-row>

											<!-- 右侧列表 -->
											<el-col :span="24">

												<el-row style="padding-left: 46px; padding-top: 20px;">

													<el-col :span="7">
														<span>时间</span>
														<el-date-picker v-model="condition.years_date" type="month"
															placeholder="请选择" value-format="yyyy-MM"
															style="margin-left: 10px;">
														</el-date-picker>
													</el-col>

													<el-col :span="2">
														<el-button
															style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
															@click="Findxj">
															查询</el-button>
													</el-col>

													<el-col :span="2">
														<el-button
															style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
															@click="openfileUrl()">导入</el-button>
													</el-col>
													<el-dialog title="导入" :visible.sync="dialogVisibledr" width="30%"
														@close='closeDialog' :before-close="handleClose">
														<el-upload class="upload-demo" ref="adModel"
															:action="$globals.http + '/file/upload'" multiple
															:file-list="fileList" :on-success="handleAvatarSuccess"
															:on-remove="handleRemove">
															<el-button
																style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
																选择文件</el-button>
														</el-upload>
														<div style="margin-top: 30px;">
															<div style="font-size: 18px;" v-if="fileDatatitle">导入失败人员姓名：
															</div>
															<div
																style="display: flex; justify-content: flex-start;flex-wrap: wrap;">
																<div v-for="(item,index) in fileData"
																	style="flex:1; width: calc((100% - 20px) / 5);min-width: calc((100% - 20px) / 5);max-width: calc((100% - 20px) / 5);">
																	<div>{{item}}</div>
																</div>
															</div>
														</div>
														<el-button type="primary"
															style=" background-color: #006E4B; border: 1px solid #006E4B;margin: 30px 0 0 40%;"
															@click="savefileUrl()">确 定</el-button>
													</el-dialog>

													<el-col :span="2">
														<download-excel class="export-excel-wrapper"
															:fields="download_excel" :name="condition.project_name"
															:fetch="ExportForm" style="top:100px;width:5%">
															<el-button
																style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
																导出</el-button>
														</download-excel>
													</el-col>

													<el-col :span="2">
														<el-button
															style="width: 110px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
															@click="heavyloadkq"
															v-loading.fullscreen.lock="fullscreenLoading">
															更新考勤表</el-button>
													</el-col>

													<el-col :span="2">
														<el-button
															style="width: 110px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;margin-left: 25px;"
															@click="heavyload"
															v-loading.fullscreen.lock="fullscreenLoading">
															更新工资表</el-button>
													</el-col>
												</el-row>

												<el-row style="margin: 0px 2%; margin-top: 10px; font-weight: bold;">
													<el-col :span="3">
														<span>实际出勤人数：{{total || '0'}}</span>
													</el-col>
													<el-col :span="8">
														<span>项目名称：{{condition.project_name}}</span>
													</el-col>
													<el-col :span="4">
														<div style="margin-top: 5px;">
															<el-radio v-model="condition.actual_estimate" label="1">预估
															</el-radio>
															<el-radio v-model="condition.actual_estimate" label="0">实开
															</el-radio>
														</div>
													</el-col>
													<el-col :span="4">
														<div v-if="this.kqje == null">
															<span>开票金额：</span>
															<el-input v-model="condition.invoiced_amount" size="mini" type="number"
																placeholder=" " style="width: 50%; margin-left: 2px;"
																clearable></el-input>
														</div>
													</el-col>
													<el-col :span="4">
														<div v-if="this.kqje !== null">
															<span>开票金额：{{kqje}}</span>
														</div>
													</el-col>
													<el-col :span="2">
														<button v-if="this.kqje == null" style="width: 75px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B; 
						                                        height:28px;text-align:center:padding:auto;border-radius:5px ;"
															@click="savexj">
															确定</button>
													</el-col>

												</el-row>

												<el-row style="margin: 0px 2%; margin-top: 10px; font-weight: bold;">

													<el-col :span="4">
														<div v-if="this.kqje1 == null">
															<span>实际物料：</span>
															<el-input v-model="condition.actual_material" size="mini"
																placeholder=" " style="width: 50%; margin-left: 2px;"
																clearable></el-input>
														</div>
													</el-col>
													<el-col :span="4">
														<div v-if="this.kqje1 !== null">
															<span>实际物料：{{kqje1}}</span>
														</div>
													</el-col>


													<el-col :span="4">
														<div v-if="this.kqje2 == null">
															<span>临采物料：</span>
															<el-input v-model="condition.temporary_materials"
																size="mini" placeholder=" "
																style="width: 50%; margin-left: 2px;" clearable>
															</el-input>
														</div>
													</el-col>
													<el-col :span="4">
														<div v-if="this.kqje2 !== null">
															<span>临采物料：{{kqje2}}</span>
														</div>
													</el-col>


													<el-col :span="6">
														<div v-if="this.kqje3 == null">
															<span>工资绩效考核定额：</span>
															<el-input v-model="condition.salary_performance" size="mini"
																placeholder=" " style="width: 50%; margin-left: 2px;"
																clearable></el-input>
														</div>
													</el-col>
													<el-col :span="6">
														<div v-if="this.kqje3 !== null">
															<span>工资绩效考核定额：{{kqje3}}</span>
														</div>
													</el-col>


													<el-col :span="5">
														<div v-if="this.kqje4 == null">
															<span>预算定额人数：</span>
															<el-input v-model="condition.budget_quota_number"
																size="mini" placeholder=" "
																style="width: 50%; margin-left: 2px;" clearable>
															</el-input>
														</div>
													</el-col>
													<el-col :span="5">
														<div v-if="this.kqje4 !== null">
															<span>预算定额人数：{{kqje4}}</span>
														</div>
													</el-col>


												</el-row>

												<el-row style="margin: 0px 2%;">
													<el-row style="margin-top: 5px;">
														<el-table v-tableFit
															:header-cell-style="{background:'#d3eae2',color:'#000000'}"
															:border="true" :row-class-name="tableRowClassName"
															ref="table" :data="tableData" show-summary
															:summary-method="getSummaries" height="590"
															tooltip-effect="dark" style="width: 100%;"
															@selection-change="handleSelectionChange">
															<el-table-column align="center" label="序号" width="50"
																fixed="left">
																<template
																	slot-scope="scope_1">{{scope_1.$index + 1}}</template>
															</el-table-column>
															<el-table-column prop="post_name" align="center" label="岗位"
																width="70" fixed="left"></el-table-column>
															<el-table-column prop="staff_name" align="center" label="姓名"
																width="70" fixed="left"></el-table-column>
															<el-table-column prop="total_wages" align="center"
																label="工资总额" width="60" fixed="left"></el-table-column>
															<el-table-column prop="base_pay" align="center" label="基本工资"
																width="60"></el-table-column>
															<el-table-column prop="post_salary" align="center"
																label="岗位工资" width="60"></el-table-column>
															<el-table-column prop="daily_wage" align="center"
																label="日工资" width="60"></el-table-column>
															<el-table-column prop="days_attendance" align="center"
																label="应出勤天数" width="70"></el-table-column>
															<el-table-column align="center" label="事假/缺勤">
																<el-table-column prop="absence_days" align="center"
																	label="天数" width="60"></el-table-column>
																<el-table-column prop="deduction_absence" align="center"
																	label="扣款" width="60"></el-table-column>
															</el-table-column>
															<el-table-column prop="actual_attendance_days"
																align="center" label="实出勤天数" width="70">
															</el-table-column>
															<el-table-column prop="wages" align="center" label="工资额"
																width="60"></el-table-column>
															<el-table-column align="center" label="增补项">
																<el-table-column prop="full_work_attendance"
																	align="center" label="满勤" width="60">
																	<template slot-scope="scope">
																		<el-input v-show="scope.row.show"
																			v-model="scope.row.full_work_attendance"
																			size="mini"
																			style="margin-left:-5px; width: 70px;">
																		</el-input>
																		<span
																			v-show="!scope.row.show">{{ scope.row.full_work_attendance}}</span>
																	</template>
																</el-table-column>
																<el-table-column prop="meal_supplement" align="center"
																	label="餐补" width="60">
																	<template slot-scope="scope">
																		<el-input v-show="scope.row.show"
																			v-model="scope.row.meal_supplement"
																			size="mini"
																			style="margin-left:-5px; width: 70px;">
																		</el-input>
																		<span
																			v-show="!scope.row.show">{{ scope.row.meal_supplement}}</span>
																	</template>
																</el-table-column>
																<el-table-column prop="overtime" align="center"
																	label="加班时间" width="60"></el-table-column>
																<el-table-column prop="overtime_amount" align="center"
																	label="加班金额" width="60">
																	<template slot-scope="scope">
																		<el-input v-show="scope.row.show"
																			v-model="scope.row.overtime_amount"
																			size="mini"
																			style="margin-left:-5px; width: 70px;">
																		</el-input>
																		<span
																			v-show="!scope.row.show">{{ scope.row.overtime_amount}}</span>
																	</template>
																</el-table-column>
																<el-table-column prop="substitute" align="center"
																	label="替班" width="60">
																	<template slot-scope="scope">
																		<el-input v-show="scope.row.show"
																			v-model="scope.row.substitute" size="mini"
																			style="margin-left:-5px; width: 70px;">
																		</el-input>
																		<span
																			v-show="!scope.row.show">{{ scope.row.substitute}}</span>
																	</template>
																</el-table-column>
																<el-table-column prop="telephone_charges" align="center"
																	label="话费" width="60">
																	<template slot-scope="scope">
																		<el-input v-show="scope.row.show"
																			v-model="scope.row.telephone_charges"
																			size="mini"
																			style="margin-left:-5px; width: 70px;">
																		</el-input>
																		<span
																			v-show="!scope.row.show">{{ scope.row.telephone_charges}}</span>
																	</template>
																</el-table-column>
																<el-table-column prop="substitute_salary" align="center"
																	label="代岗工资" width="60">
																	<template slot-scope="scope">
																		<el-input v-show="scope.row.show"
																			v-model="scope.row.substitute_salary"
																			size="mini"
																			style="margin-left:-5px; width: 70px;">
																		</el-input>
																		<span
																			v-show="!scope.row.show">{{ scope.row.substitute_salary}}</span>
																	</template>
																</el-table-column>
																<el-table-column prop="make_up_for_the_early_stage"
																	align="center" label="弥补前期" width="60">
																	<template slot-scope="scope">
																		<el-input v-show="scope.row.show"
																			v-model="scope.row.make_up_for_the_early_stage"
																			size="mini"
																			style="margin-left:-5px; width: 70px;">
																		</el-input>
																		<span
																			v-show="!scope.row.show">{{ scope.row.make_up_for_the_early_stage}}</span>
																	</template>
																</el-table-column>
																<el-table-column prop="reward" align="center" label="奖励"
																	width="60">
																	<template slot-scope="scope">
																		<el-input v-show="scope.row.show"
																			v-model="scope.row.reward" size="mini"
																			style="margin-left:-5px; width: 70px;">
																		</el-input>
																		<span
																			v-show="!scope.row.show">{{ scope.row.reward}}</span>
																	</template>
																</el-table-column>
																<el-table-column prop="return_of_work_clothes_deposit"
																	align="center" label="归还工服押金" width="70">
																	<template slot-scope="scope">
																		<el-input v-show="scope.row.show"
																			v-model="scope.row.return_of_work_clothes_deposit"
																			size="mini"
																			style="margin-left:-5px; width: 70px;">
																		</el-input>
																		<span
																			v-show="!scope.row.show">{{ scope.row.return_of_work_clothes_deposit}}</span>
																	</template>
																</el-table-column>
																<el-table-column prop="other_plus" align="center"
																	label="其他+" width="60">
																	<template slot-scope="scope">
																		<el-input v-show="scope.row.show"
																			v-model="scope.row.other_plus" size="mini"
																			style="margin-left:-5px; width: 70px;">
																		</el-input>
																		<span
																			v-show="!scope.row.show">{{ scope.row.other_plus}}</span>
																	</template>
																</el-table-column>
															</el-table-column>
															<el-table-column align="center" label="扣款项">
																<el-table-column prop="late_deduction" align="center"
																	label="迟到扣款" width="60">
																	<template slot-scope="scope">
																		<el-input v-show="scope.row.show"
																			v-model="scope.row.late_deduction"
																			size="mini"
																			style="margin-left:-5px; width: 70px;">
																		</el-input>
																		<span
																			v-show="!scope.row.show">{{ scope.row.late_deduction}}</span>
																	</template>
																</el-table-column>
																<el-table-column prop="penalty_deduction" align="center"
																	label="处罚扣款" width="60">
																	<template slot-scope="scope">
																		<el-input v-show="scope.row.show"
																			v-model="scope.row.penalty_deduction"
																			size="mini"
																			style="margin-left:-5px; width: 70px;">
																		</el-input>
																		<span
																			v-show="!scope.row.show">{{ scope.row.penalty_deduction}}</span>
																	</template>
																</el-table-column>
																<el-table-column prop="pay_the_work_clothes_deposit"
																	align="center" label="发放工服押金" width="70">
																	<template slot-scope="scope">
																		<el-input v-show="scope.row.show"
																			v-model="scope.row.pay_the_work_clothes_deposit"
																			size="mini"
																			style="margin-left:-5px; width: 70px;">
																		</el-input>
																		<span
																			v-show="!scope.row.show">{{ scope.row.pay_the_work_clothes_deposit}}</span>
																	</template>
																</el-table-column>
																<el-table-column prop="other_reduce" align="center"
																	label="其他-" width="60">
																	<template slot-scope="scope">
																		<el-input v-show="scope.row.show"
																			v-model="scope.row.other_reduce" size="mini"
																			style="margin-left:-5px; width: 70px;">
																		</el-input>
																		<span
																			v-show="!scope.row.show">{{ scope.row.other_reduce}}</span>
																	</template>
																</el-table-column>
															</el-table-column>
															<!-- <el-table-column align="center" label="补贴项(职能人员用)">
																<el-table-column prop="car_supplement" align="center"
																	label="车补" width="60"></el-table-column>
																<el-table-column prop="overseas_subsidies"
																	align="center" label="驻外补助" width="60">
																</el-table-column>
																<el-table-column prop="other_subsidies" align="center"
																	label="其他补贴" width="60"></el-table-column>
																<el-table-column prop="subtotal_of_subsidies_payable"
																	align="center" label="应发补贴小计" width="70">
																</el-table-column>
																<el-table-column prop="subtotal_of_subsidies_paid"
																	align="center" label="实发补贴小计" width="70">
																</el-table-column>
															</el-table-column> -->
															<el-table-column prop="wages_payable" align="center"
																label="应发工资" width="60"></el-table-column>
															<el-table-column align="center" label="代扣代缴">
																<el-table-column prop="social_security_deduction"
																	align="center" label="社保扣款" width="60">
																</el-table-column>
																<el-table-column prop="accident_insurance"
																	align="center" label="意外保险" width="60">
																</el-table-column>
																<el-table-column prop="accumulation_fund" align="center"
																	label="公积金" width="60"></el-table-column>
															</el-table-column>
															<el-table-column prop="before_tax_paid_salary"
																align="center" label="实发工资(税前)" width="80">
															</el-table-column>
															<el-table-column prop="individual_income_tax" align="center"
																label="个人所得税" width="70"></el-table-column>
															<el-table-column prop="after_tax_paid_salary" align="center"
																label="实发工资(税后)" width="80"></el-table-column>
															<el-table-column prop="receiving_method_name" align="center"
																label="领取方式" width="60">
																<template slot-scope="scope">
																	<el-select v-show="scope.row.show"
																		style="margin-right:10px"
																		v-model="scope.row.receiving_method" clearable
																		size="mini">
																		<el-option v-for="item in lqList"
																			:value="item.value" :key="item.value"
																			:label="item.label">
																		</el-option>
																	</el-select>
																	<span
																		v-show="!scope.row.show">{{scope.row.receiving_method_name}}</span>
																</template>
															</el-table-column>
															<el-table-column prop="bank_card_number" align="center"
																label="银行卡号" width="100">
																<template slot-scope="scope">
																	<el-input v-show="scope.row.show"
																		v-model="scope.row.bank_card_number" size="mini"
																		style="margin-left:-5px; width: 150px;">
																	</el-input>
																	<span
																		v-show="!scope.row.show">{{ scope.row.bank_card_number}}</span>
																</template>
															</el-table-column>
															<el-table-column prop="cardholder_name" align="center"
																label="持卡人" width="70">
																<template slot-scope="scope">
																	<el-input v-show="scope.row.show"
																		v-model="scope.row.cardholder_name" size="mini"
																		style="margin-left:-5px; width: 150px;">
																	</el-input>
																	<span
																		v-show="!scope.row.show">{{ scope.row.cardholder_name}}</span>
																</template>
															</el-table-column>
															<el-table-column prop="entry_name" align="center"
																label="项目名称" width="100"></el-table-column>
															<el-table-column prop="id_card" align="center" 
																label="身份证号" width="100">
																<template slot-scope="scope">
																	<el-input v-show="scope.row.show"
																		v-model="scope.row.id_card" size="mini"
																		style="margin-left:-5px; width: 150px;">
																	</el-input>
																	<span
																		v-show="!scope.row.show">{{ scope.row.id_card}}</span>
																</template>
															</el-table-column>
															<el-table-column prop="telephone_number" align="center"
																label="电话号" width="100">
																<template slot-scope="scope">
																	<el-input v-show="scope.row.show"
																		v-model="scope.row.telephone_number" size="mini"
																		style="margin-left:-5px; width: 150px;">
																	</el-input>
																	<span
																		v-show="!scope.row.show">{{ scope.row.telephone_number}}</span>
																</template>
															</el-table-column>
															<el-table-column prop="gender" align="center" 
																label="性别" width="60"></el-table-column>
															<el-table-column align="center" label="操作" width="150"
																fixed="right">
																<template slot-scope="scope">
																	<button
																		style="width: 50px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;border-radius: 5px"
																		@click="edit(scope.$index, scope.row)">编辑</button>
																	<button
																		style="width: 50px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;border-radius: 5px"
																		@click="save(scope.$index, scope.row)">保存</button>
																	<!-- <img src="../../../assets/编辑.png" @click="Edit(scope.row)" /> -->
																</template>
															</el-table-column>
														</el-table>
													</el-row>
												</el-row>

											</el-col>
										</el-row>

									</div>
								</el-row>
							</div>

							<div v-if="dialogVisible">
								<edit ref="edit"></edit>
							</div>

						</div>
					</el-tab-pane>

					<el-tab-pane label="支援工资明细表" name="ZyGzmx">
						<ZyGzmx ref="ZyGzmx" :from="from" :condition="condition" v-show="!is_edit"></ZyGzmx>
						
					</el-tab-pane>
				</el-tabs>
			</el-col>
		</el-row>
		<el-dialog title="审批人" :visible.sync="sprdialogVisible" width="40%" :before-close="handleClose">
			<el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
				<el-form-item label="审批名称">
					<el-input v-model="reviewData.examine_name" style="width: 400px;"></el-input>
				</el-form-item>
				<el-table :data="reviewData.examineDetailsList" style="width: 100%">
					<el-table-column prop="node" label="节点" align="center"></el-table-column>
					<el-table-column prop="role_name" label="岗位" align="center"></el-table-column>
					<el-table-column prop="staff_name" label="姓名" align="center">
						<template slot-scope="scope">
							<el-select v-model="scope.row.ids" multiple collapse-tags placeholder="请选择"
								v-if="scope.row.staff_ids == '' || scope.row.staff_ids == null" style="width: 150px;">
								<el-option v-for="item in options" :key="item.id" :label="item.staff_name"
									:value="item.staff_id">
								</el-option>
							</el-select>
							<span
								v-if="scope.row.staff_ids != '' || scope.row.staff_ids != null">{{scope.row.staff_name}}</span>
						</template>
					</el-table-column>
				</el-table>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" style=" background-color: #006E4B; border: 1px solid #006E4B;"
					@click="sprSave()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import Structure from "../../utils/structure/structure.vue";
	import XmGzmx from "./tabs/XmGzmx.vue";
	import ZyGzmx from "./tabs/ZyGzmx.vue";
	import axios from "axios";
	export default {
		components: {
			XmGzmx: XmGzmx,
			ZyGzmx: ZyGzmx,
			Structure: Structure,
		},
		data() {
			return {
				//列表相关
				page_num: 1,
				page_size: 10,
				total: 0,
				is_edit: false,
				activeName: "XmGzmx",
				labelPosition: 'right',
				//页面相关
				dialogVisible: false,
				sprdialogVisible: false,
				dialogVisibledr: false,

				fullscreenLoading: false,
				reviewData: [], //审批
				options: [],
				tableData: [],
				tableDatas: [],
				List: [],
				formLabelAlign: {
					name: '',
				},
				// 领取方式
				lqList: [{
					value: "0",
					label: '现金'
				}, {
					value: "1",
					label: '银行卡'
				}, 
				{
					value: "2",
					label: '代发'
				},

				{
					value: "3",
					label: '银行卡-待开'
				},
				
				],


				kqje: null,
				kqje1: null,
				kqje2: null,
				kqje3: null,
				kqje4: null,

				//职位下拉 
				postList: [],

				download_excel: {
					"姓名": "cardholder_name",
					"岗位": "post_name",
					"工资总额": "total_wages",
					"基本工资": "base_pay",
					"岗位工资": "post_salary",
					"日工资": "daily_wage",
					"应出勤天数": "days_attendance",
					"事假/缺勤 - 天数": "absence_days",
					"事假/缺勤 - 扣款": "deduction_absence",
					"实出勤天数": "actual_attendance_days",
					"工资额": "wages",
					"增补项 - 满勤": "full_work_attendance",
					"增补项 - 餐补": "meal_supplement",
					"增补项 - 加班时间": "overtime",
					"增补项 - 加班金额": "overtime_amount",
					"增补项 - 替班": "substitute",
					"增补项 - 话费": "telephone_charges",
					"增补项 - 代岗工资": "substitute_salary",
					"增补项 - 弥补前期": "make_up_for_the_early_stage",
					"增补项 - 奖励": "reward",
					"增补项 - 归还工资押金": "return_of_work_clothes_deposit",
					"增补项 - 其他+": "other_plus",
					"扣款项 - 迟到扣款": "late_deduction",
					"扣款项 - 处罚扣款": "penalty_deduction",
					"扣款项 - 发放工服押金": "pay_the_work_clothes_deposit",
					"扣款项 - 其他-": "other_reduce",
					"补贴项 - 车补": "car_supplement",
					"补贴项 - 驻外补助": "overseas_subsidies",
					"补贴项 - 其他补贴": "other_subsidies",
					"补贴项 - 应发补贴小计": "subtotal_of_subsidies_payable",
					"补贴项 - 实发补贴小计": "subtotal_of_subsidies_paid",
					"应发工资": "wages_payable",
					"代扣代缴 - 社保扣款": "social_security_deduction",
					"代扣代缴 - 意外保险": "accident_insurance",
					"代扣代缴 - 公积金": "accumulation_fund",
					"实发工资（税前）": "before_tax_paid_salary",
					"个人所得税": "individual_income_tax",
					"实发工资（税后）": "after_tax_paid_salary",
					"领取方式": "receiving_method_name",
					"银行卡号": {
						field: "bank_card_number",
						callback: value => {
							return "&nbsp;" + value;
						}
					},
					"持卡人": "cardholder_name",
					"项目名称": "entry_name",
					"身份证号": {
						field: "id_card",
						callback: value => {
							return "&nbsp;" + value;
						}
					},
					"电话号": "telephone_number",
					"性别": "gender",
				},

				//条件
				condition: {
					project_id: "",
					flag: "",
					post_id: "",
					staff_name: "",
					project_name: "",
					invoiced_amount: "",
					actual_material: "",
					temporary_materials: "",
					salary_performance: "",
					budget_quota_number: "",
					actual_estimate: "1",
					years_date: this.$globals.getNowTimes(),
				},

				//详情
				from: {
					id: '',
					project_name: '',
					invoiced_amount: '',
				},
				sprData: [],
				fileurl: "",
				fileData: [],
				fileDatatitle: false,

				//复选框ids
				ids: [],
			};
		},
		// 合计
		updated() {
			this.$nextTick(() => {
				this.$refs['table'].doLayout();
			})
		},

		methods: {
			handleClick(tab, event) {
				console.log(tab, event);
				if (tab.name == 'XmGzmx') {
					this.Findxj();
				} else {
					this.Findzy();
				}
			},
			closeDialog() {
				this.$refs.adModel.clearFiles()
			},
			openfileUrl() {
				this.dialogVisibledr = true;
				this.fileurl = "";
				this.fileDatatitle = false;
				this.fileData = [];
			},
			handleAvatarSuccess(res, file) {
				this.fileurl = res.data.fileUrl;
			},

			//导入
			savefileUrl() {

				const url = this.$globals.http + "file/uploadSalary";
				axios.post(url, {
					file_Route: this.fileurl,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;


					if (code === '200') {
						if (data === [] || data === '') {
							this.$message.success('导入成功！');
							this.dialogVisibledr = false;
						} else {
							this.$message.success('导入失败！');
							this.fileData = data;
							this.fileDatatitle = true;
							this.fileurl = '';
							// console.log(this.fileData)
						}

					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}).catch((error) => {
					console.log(error)
					this.$message.error("服务器未响应！请稍后重试");
				})

			},
			Find() {
				this.Findxj();
				this.Findzy();
			},
			//点击编辑
			edit(index, row) {
				row.show = true;
				this.$set(this.$refs.table.tableData, index, row);
			},
			//点击保存
			save(index, row) {
				// var url = 'Salary/updateSalaryDetails';
				var record = {
					applicant_id: this.$globals.user.staff_id,
					id: row.id,
					wages: row.wages,
					bank_card_number: row.bank_card_number,
					receiving_method: row.receiving_method,
					other_reduce: row.other_reduce,
					pay_the_work_clothes_deposit: row.pay_the_work_clothes_deposit,
					penalty_deduction: row.penalty_deduction,
					late_deduction: row.late_deduction,
					other_plus: row.other_plus,
					return_of_work_clothes_deposit: row.return_of_work_clothes_deposit,
					reward: row.reward,
					make_up_for_the_early_stage: row.make_up_for_the_early_stage,
					substitute_salary: row.substitute_salary,
					telephone_charges: row.telephone_charges,
					substitute: row.substitute,
					overtime_amount: row.overtime_amount,
					meal_supplement: row.meal_supplement,
					full_work_attendance: row.full_work_attendance,
					social_security_deduction: row.social_security_deduction,
					accident_insurance: row.accident_insurance,
					accumulation_fund: row.accumulation_fund,
					individual_income_tax: row.individual_income_tax,

					telephone_number: row.telephone_number,
					id_card: row.id_card,
					cardholder_name: row.cardholder_name,

				};


				const url = this.$globals.http + "/Salary/updateSalaryDetails";
				axios.post(url, record ).then((response) => {
					var code = response.data.code;
					var data = response.data.data;

					if (code === '200') {
						this.$message.success('修改成功！');
						row.show = false;
						this.$set(this.$refs.table.tableData, index, row);
					} else {
						
						this.$message.warning(data);
					}
				}).catch((error) => {
					console.log(error)
					row.show = false;
					this.$message.error("服务器未响应！请稍后重试");
				})


				// var data = this.$globals.AxiosPost(url, record);
				// debugger
				// if (data === '-2000') {
				// 	this.$message.error('服务器未响应！请稍后重试');
				// } else {
				// 	this.$message.success('修改成功！');
				// 	row.show = false;
				// 	this.$set(this.$refs.table.tableData, index, row);
				// }

			},

			
			//指定列求和
			getSummaries(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '合计';
						return;
					}
					const values = data.map(item => Number(item[column.property]));
					if (column.property == 'total_wages' || column.property == 'base_pay' || column.property ==
						'post_salary' ||
						column.property == 'daily_wage' ||
						column.property == 'deduction_absence' || column.property == 'wages' || column.property ==
						'full_work_attendance' || column.property == 'meal_supplement' ||
						column.property == 'overtime_amount' || column.property == 'telephone_charges' || column
						.property ==
						'substitute_salary' || column.property == 'make_up_for_the_early_stage' ||
						column.property == 'reward' || column.property == 'return_of_work_clothes_deposit' ||
						column.property ==
						'other_plus' || column.property == 'late_deduction' ||
						column.property == 'penalty_deduction' || column.property ==
						'pay_the_work_clothes_deposit' || column.property ==
						'other_reduce' || column.property == 'car_supplement' ||
						column.property == 'overseas_subsidies' || column.property == 'other_subsidies' || column
						.property ==
						'subtotal_of_subsidies_payable' || column.property == 'subtotal_of_subsidies_paid' ||
						column.property == 'before_tax_paid_salary' || column.property ==
						'individual_income_tax' || column.property ==
						'after_tax_paid_salary' || column.property == 'wages_payable' ||
						column.property == 'social_security_deduction' || column.property ==
						'accident_insurance' || column.property ==
						'accumulation_fund' || column.property == 'substitute') {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						// console.log(sums )
						// sums[index];
						sums[index] = sums[index].toFixed(2); //保留2位小数
					}
				});
				return sums
			},
			//指定列求和salaryDetails
			getSummariestwo(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '合计';
						return;
					}
					const values = data.map(item => Number(item[column.property]));
					if (column.property == 'total_wages' || column.property == 'base_pay' || column.property ==
						'post_salary' ||
						column.property == 'daily_wage' ||
						column.property == 'deduction_absence' || column.property == 'wages' || column.property ==
						'full_work_attendance' || column.property == 'meal_supplement' ||
						column.property == 'overtime_amount' || column.property == 'telephone_charges' || column
						.property ==
						'substitute_salary' || column.property == 'make_up_for_the_early_stage' ||
						column.property == 'reward' || column.property == 'return_of_work_clothes_deposit' ||
						column.property ==
						'other_plus' || column.property == 'late_deduction' ||
						column.property == 'penalty_deduction' || column.property ==
						'pay_the_work_clothes_deposit' || column.property ==
						'other_reduce' || column.property == 'car_supplement' ||
						column.property == 'overseas_subsidies' || column.property == 'other_subsidies' || column
						.property ==
						'subtotal_of_subsidies_payable' || column.property == 'subtotal_of_subsidies_paid' ||
						column.property == 'before_tax_paid_salary' || column.property ==
						'individual_income_tax' || column.property ==
						'after_tax_paid_salary' || column.property == 'wages_payable' ||
						column.property == 'social_security_deduction' || column.property ==
						'accident_insurance' || column.property ==
						'accumulation_fund' || column.property == 'substitute') {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						// console.log(sums )
						// sums[index];
						sums[index] = sums[index].toFixed(2); //保留2位小数
					}
				});
				return sums
			},
			Return() {
				this.dialogVisible = false;
			},
			// 确定
			savexj() {
				const url = this.$globals.http + "/Regional/selectExamine";
				axios.post(url, {
					organize_id: this.condition.project_id,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;
					if (code === '200') {
						this.reviewData = response.data.data;
						this.reviewData.examine_name = '工资明细审批' + ' (' + this.condition.years_date + ')' + this
							.condition.project_name;
						this.sprdialogVisible = true;
						this.infoFind();
					} else {
						this.$message.warning("没有能匹配的审批流");
					}
				}).catch((error) => {
					console.log(error)
					this.$message.error("服务器未响应！请稍后重试");
				})
			},
			infoFind() {
				axios.get(this.$globals.http + 'user/selectOrganizeSysUser', {
					params: {
						info: this.condition.project_id
					}
				}).then(res => {
					this.options = res.data.data;
				}).catch(err => {
					console.log(err)
				})
			},

			sprSave() {
				const url = this.$globals.http + "Regional/insertRegional";
				axios.post(url, {
					actual_estimate: this.condition.actual_estimate,
					organize_id: this.condition.project_id,
					years_date: this.condition.years_date,
					invoiced_amount: this.condition.invoiced_amount,
					actual_material: this.condition.actual_material,
					temporary_materials: this.condition.temporary_materials,
					salary_performance: this.condition.salary_performance,
					budget_quota_number: this.condition.budget_quota_number,
					spare6:this.total,
					applicant_id: this.$globals.user.staff_id,
					examine: this.reviewData,
					// salaryDetails: this.tableData,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;

					if (code === '200') {
						this.List = data;
						this.sprdialogVisible = false;
						this.Findxj();
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}).catch((error) => {
					console.log(error)
					this.$message.error("服务器未响应！请稍后重试");
				})
			},
			//查询
			Findxj() {
				this.kqje = '';
				this.kqje1 = '';
				this.kqje2 = '';
				this.kqje3 = '';
				this.kqje4 = '';
				this.condition.actual_estimate = '1';
				const url = this.$globals.http + "Regional/WagesRegional";
				axios.post(url, {
					organize_id: this.condition.project_id,
					years_date: this.condition.years_date,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;

					if (code === '200') {
						this.kqje = data.invoiced_amount;
						this.kqje1 = data.actual_material;
						this.kqje2 = data.temporary_materials;
						this.kqje3 = data.salary_performance;
						this.kqje4 = data.budget_quota_number;
						this.tableData = data.salaryDetails;
						this.total = data.spare6;
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}).catch((error) => {
					console.log(error)
					this.$message.error("服务器未响应！请稍后重试");
				})
			},
			// 确定
			savezy() {
				const url = this.$globals.http + "/Regional/Total";
				axios.post(url, {
					organize_id: this.condition.project_id,
					years_date: this.condition.years_date,
					salaryDetails: this.tableData,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;

					if (code === '200') {
						this.List = data;
						this.Find();
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}).catch((error) => {
					console.log(error)
					this.$message.error("服务器未响应！请稍后重试");
				})
			},
			//查询
			Findzy() {
				const url = this.$globals.http + "/Salary/SupportDetailsAlls";
				axios.post(url, {
					organize_id: this.condition.project_id,
					years_date: this.condition.years_date,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;
					if (code === '200') {
						this.tableDatas = data;
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}).catch((error) => {
					console.log(error)
					this.$message.error("服务器未响应！请稍后重试");
				})
			},
			heavyloadkq() {
				this.fullscreenLoading = true;
				const url = this.$globals.http + "CheckAttendance/Generate";
				axios.post(url, {
					applicant_id: this.$globals.user.staff_id,
					project_id: this.condition.project_id,
					years_date: this.condition.years_date,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;

					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
						this.fullscreenLoading = false;
					} else {
						this.fullscreenLoading = false;
						this.$message.warning(data);
					}
				}).catch((error) => {
					console.log(error)
					this.fullscreenLoading = false;
					this.$message.error("服务器未响应！请稍后重试");
				})
			},
			//重载
			heavyload() {
				this.fullscreenLoading = true;
				const url = this.$globals.http + "/Salary/selectSupportAll";
				axios.post(url, {
					applicant_id: this.$globals.user.staff_id,
					project_id: this.condition.project_id,
					years_date: this.condition.years_date,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;

					if (code === '200') {
						this.fullscreenLoading = false;
						this.tableData = data.salaryDetails;
					} else {
						this.fullscreenLoading = false;
						this.$message.warning(data);
					}
				}).catch((error) => {
					console.log(error)
					this.fullscreenLoading = false;
					this.$message.error("服务器未响应！请稍后重试");
				})
			},
			//导表
			async ExportForm() {
				var url = 'Regional/WagesRegional';
				var record = {
					organize_id: this.condition.project_id,
					years_date: this.condition.years_date,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data.salaryDetails;
					if (code === '200') {
						this.tableData
						if (this.tableData.length > 0) {
							this.$message.success("导表成功！文件下载中！");
							return this.tableData;
						} else {
							this.$message.success("没有可以导出的数据！");
							return null;
						}

					}
				}
			},

			async ExportForms() {
				var url = 'Regional/WagesRegional';
				var record = {
					organize_id: this.condition.project_id,
					years_date: this.condition.years_date,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data.salaryDetails;
					if (code === '200') {
						this.tableData
						if (this.tableDatas.length > 0) {
							this.$message.success("导表成功！文件下载中！");
							return this.tableDatas;
						} else {
							this.$message.success("没有可以导出的数据！");
							return null;
						}

					}
				}
			},
			//详情页面
			Edit(e) {
				this.from.id = e;
				this.dialogVisible = true;
			},

		},

		async created() {
			//    this.Findxj();
			// this.Findzy();
			//初始化职位下拉
			var postList = await this.$globals.AxiosPost("post/selectFind", {});
			this.postList = postList.data;
		}

	}
</script>

<style scoped="scoped">
	>>>.el-button:hover {
		background-color: #FFFFFF;
	}

	>>>.el-button:focus {
		background-color: #FFFFFF;
	}

	>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006E4B;
	}

	>>>.el-input__inner:focus {
		border-color: #006E4B;
	}

	>>>.el-select .el-input.is-focus .el-input__inner {
		border-color: #006E4B;
	}

	>>>.el-checkbox__input.is-checked .el-checkbox__inner,
	>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #006E4B;
		border-color: #006E4B;
	}

	>>>.el-checkbox__inner:hover {
		border-color: #006E4B;
	}

	>>>.el-tabs__header {
		margin: auto !important;
	}

	>>>.el-tree-node.is-expanded>.el-tree-node__children {
		display: inline;
	}
	.tabs .el-tabs__header{
		margin: 0px;
	}
	.tabs .el-tabs__item.is-active {
		color: #fff;
		background-color: #006E4B;
	}
	.tabs .el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
		border-bottom-color: none;
	}
	
	.tabs .el-tabs__active-bar {
		background-color: #006E4B;
	}
	
	.tabs .el-tabs__item:hover {
		color: #d3eae2;
	}
	.tabs .el-tabs--card>.el-tabs__header{
		border-bottom: 0px;
	}

	  	
	/* ::-webkit-scrollbar {
      width: 10px !important;
      height:10px !important;
      background-color: #8487879e;
  	}
 
  	.el-table__fixed::before, .el-table__fixed-right::before {
		content: '';
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 1px;
		background-color: unset;
		z-index: 4;
	} */
</style>



// WEBPACK FOOTER //
// GzMx.vue?79c47826